import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),

  AdMedia: lazyNamed(() => import('./containers/AdMedia'), 'AdMedia'),
  AdMediaHistory: lazyNamed(() => import('./containers/AdMedia/containers/AdMediaHistory'), 'AdMediaHistory'),

  AdPrices: lazyNamed(() => import('./containers/AdPrices'), 'AdPrices'),
  AdPriceForm: lazyNamed(() => import('./containers/AdPrices/containers/AdPriceForm'), 'AdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./containers/AdPrices/containers/AdPriceHistory'), 'AdPriceHistory'),

  AdTypes: lazyNamed(() => import('./containers/AdTypes'), 'AdTypes'),
  AdTypeHistory: lazyNamed(() => import('./containers/AdTypes/containers/AdTypeHistory'), 'AdTypeHistory'),

  Placements: lazyNamed(() => import('./containers/Placements'), 'Placements'),
  PlacementHistory: lazyNamed(() => import('./containers/Placements/containers/PlacementHistory'), 'PlacementHistory'),

  Products: lazyNamed(() => import('./containers/Products'), 'Products'),
  ProductForm: lazyNamed(() => import('./containers/Products/containers/ProductForm'), 'ProductForm'),
  ProductHistory: lazyNamed(() => import('./containers/Products/containers/ProductHistory'), 'ProductHistory'),
};
